import { Box, Typography } from "@material-ui/core";
import GenericButton from "components/Buttons/GenericButton";
import GenericDialog from "components/Dialogs/GenericDialogV2";
import FormDropdown from "components/FormFields/FormDropdown";
import FormInputV2 from "components/FormFields/FormInputV2";
import { ConditionGuard } from "guards/ConditionGuard";
import { useDataset } from "hooks/useDataset";
import { useEffect, useMemo } from "react";
import { useForm } from "react-hook-form";
import { DATASET } from "utils/const";

const BulkActionConfirmModal = ({ open, handleClose, actionType, onConfirm, isLoading }) => {
  const isActivate = actionType === "activate";
  const { control, handleSubmit, reset, watch } = useForm({
    defaultValues: {
      motiveId: null,
      otherMotiveDescription: "",
    },
    shouldFocusError: false,
  });

  const { data: INACTIVE_EMPLOYEE_MOTIVES, isLoading: motivesLoading } = useDataset({
    name: DATASET.INACTIVE_EMPLOYEE_MOTIVES,
  });
  
  const title = isActivate ? "ACTIVAÇÃO" : "INACTIVAÇÃO";
  const message = `Deseja confirmar a ${title} dos trabalhadores selecionados?`;

  useEffect(() => {
    if (open) {
      reset({
        motiveId: null,
        otherMotiveDescription: "",
      });
    }
  }, [open, actionType, reset]);

  const showObservationInput = useMemo(() => {
    if (isActivate) return false;
    return INACTIVE_EMPLOYEE_MOTIVES?.find((motive) => motive.keyValue === "OTHER")?.code === watch("motiveId");
  }, [INACTIVE_EMPLOYEE_MOTIVES, isActivate, watch]);

  const handleConfirm = () => {
    if (isActivate) return onConfirm?.();
    return handleSubmit((data) => onConfirm?.(data))();
  };

  const disableConfirm = isLoading || (!isActivate && !watch("motiveId"));

  return (
    <GenericDialog open={open} onClose={handleClose} fullWidth={true} maxWidth="sm">
      <Typography
        style={{
          fontSize: "1.6rem",
          marginBottom: "2rem",
        }}
        variant="h2"
        color="primary"
      >
        Confirmar {title}
      </Typography>

      <Typography
        style={{
          fontSize: "1.2rem",
          marginBottom: "2rem",
        }}
      >
        {message}
      </Typography>

      <ConditionGuard condition={!isActivate}>
        <form>
          <FormDropdown
            control={control}
            name="motiveId"
            label="Motivo da Saída"
            options={INACTIVE_EMPLOYEE_MOTIVES}
            loading={motivesLoading}
            required
          />

          <ConditionGuard condition={showObservationInput}>
            <FormInputV2
              control={control}
              name="otherMotiveDescription"
              label="Descrição"
              isMultiLine
              rows={4}
            />
          </ConditionGuard>
        </form>
      </ConditionGuard>

      <Box display="flex" justifyContent="flex-end" gridGap={12}>
        <GenericButton color="tertiary" onClick={handleClose} disabled={isLoading}>
          NÃO
        </GenericButton>
        <GenericButton color="primary" onClick={handleConfirm} disabled={disableConfirm} isLoading={isLoading}>
          SIM
        </GenericButton>
      </Box>
    </GenericDialog>
  );
};

export default BulkActionConfirmModal;
